import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { TipologieCostruttiveComponent } from 'src/app/anagrafiche/tipologie-costruttive/tipologie-costruttive.component';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => TipologiaCostruttivaPickerComponent) },
  ],
  selector: 'tipologia-costruttiva-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class TipologiaCostruttivaPickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(TipologieCostruttiveComponent, { data: { selectionMode: true } }).afterClosed();
  };


}
